import Api from '@/services/Api'

export default {
  getGiftPosts (data) {
    return Api().get('/posts/gift', {params: data})
  },
  getPromoPosts (data) {
    return Api().get('/posts/boosted', {params: data})
  },
  getPostById (data) {
    return Api().get('/posts/' + data.id)
  },
  getSavedPosts (data) {
    return Api().get('/posts/' + data.id + '/saved')
  },
  getRelatedPosts (data) {
    return Api().get('/posts/' + data.id + '/related', {params: data})
  },
  adInteractionDislike (data) {
    return Api().delete('/posts/' + data.adId + '/dislike')
  },
  interaction (data) {
    return Api().post('/posts/' + data.adId + '/interaction', data)
  }
}



// WEBPACK FOOTER //
// ./src/services/PostService.js